export const isDOMElement = maybeNode => maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;